import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../../common/LoadingPanel";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { authenticationService } from "../../../services/authentication.service";
import { dateConvert } from "../../common/Helpers";

class ZoznamBalikovVDodavke extends Component {
    state = {
        items: [],
        loading: true,
        selectedBalikId: null
    };
    // shouldComponentUpdate(nextProps) {
    //     if (this.props.items !== nextProps.items) {
    //         return false;
    //     }
    //     return true;
    // }

    componentDidMount() {
        const { items } = this.props;
        this.props.changeSelectedBalikId(items[0].idBaliku);
        this.setState({
            items: items,
            selectedBalikId: items[0].idBaliku,
            loading: false
        });
    }

    changeSelectedBalikId = e => {
        this.props.changeSelectedBalikId(e.dataItem.idBaliku);
        this.setState({
            selectedBalikId: e.dataItem.idBaliku
        });
    };

    renderTable(items) {
        var localizationService = provideLocalizationService(this);

        return (
            <div id="ZoznamBalikovVDodavke">
                <Grid
                    data={items.map(item => ({ ...item, selected: item.idBaliku === this.state.selectedBalikId }))}
                    total={items ? items.length : 0}
                    pageSize={items ? items.length : 0}
                    pageable={{ buttonCount: 0, info: true, pageSizes: false, previousNext: false }}
                    selectedField="selected"
                    onRowClick={this.changeSelectedBalikId}>
                    <GridColumn field="packing" title={localizationService.toLanguageString("DodavkaBaliky.Grid.Balík/Lot", "Balík/Lot")} width="110px" />
                    <GridColumn field="typTovaru" title={localizationService.toLanguageString("DodavkaBaliky.Grid.Typ", "Typ")} width="40px" />
                    <GridColumn field="pocetKusu" title={localizationService.toLanguageString("DodavkaBaliky.Grid.Ks", "Ks")} width="40px" />
                    <GridColumn field="stavString" title={localizationService.toLanguageString("DodavkaBaliky.Grid.Stav B/L", "Stav B/L")} />
                    <GridColumn field="rozdilKusuString" title={localizationService.toLanguageString("DodavkaBaliky.Grid.Stav ks", "Stav ks")} />
                    <GridColumn
                        field="pocetNaskenovanychKusu"
                        title={localizationService.toLanguageString("DodavkaBaliky.Grid.Sken.ks", "Sken.ks")}
                        width="60px"
                    />
                    <GridColumn field="skenovalUzivatel" title={localizationService.toLanguageString("DodavkaBaliky.Grid.Skenoval", "Skenoval")} />
                    <GridColumn field="datumSkenovaniaString" title={localizationService.toLanguageString("DodavkaBaliky.Grid.Dátum", "Dátum")} width="110px" />
                </Grid>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderTable(this.state.items);

        return <div>{contents}</div>;
    }
}

export default ZoznamBalikovVDodavke;

registerForLocalization(ZoznamBalikovVDodavke);



// WEBPACK FOOTER //
// ./src/components/dialogs/PrijomDodavok/ZoznamBalikovVDodavke.js